import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

interface ProjectDateFieldProps {
  label: string;
  id: string;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  helperText: string;
  required?: boolean;
  minDate?: string;
  maxDate?: string;
}

const ProjectDateField: React.FC<ProjectDateFieldProps> = ({
  label,
  id,
  name,
  value,
  onChange,
  error,
  helperText,
  required = false,
  minDate,
  maxDate
}) => {
  return (
    <Box sx={{ width: '100%', maxWidth: { xs: '100%', md: '48%' }, mb: 2 }}>
      <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
        {label}
      </Typography>
      <TextField
        fullWidth
        type="date"
        id={id}
        name={name}
        value={value ? 
          // Convert dd/mm/yyyy to yyyy-mm-dd for HTML5 date input
          value.includes('/') ? 
            value.split('/').reverse().join('-') : 
            value 
          : ''}
        onChange={(e) => {
          // Convert yyyy-mm-dd to dd/mm/yyyy format
          const dateValue = e.target.value;
          if (dateValue) {
            const [year, month, day] = dateValue.split('-');
            const formattedDate = `${day}/${month}/${year}`;
            onChange({
              target: {
                name: name,
                value: formattedDate
              }
            } as any);
          } else {
            onChange(e as any);
          }
        }}
        InputLabelProps={{
          shrink: true,
        }}
        error={!!error}
        helperText={error || helperText}
        required={required}
        inputProps={{
          min: minDate,
          max: maxDate
        }}
      />
    </Box>
  );
};

export default ProjectDateField;
